<div *ngIf="isFreePlan && !isLoading"
  class="bg-red-100 border border-red-400 text-red-700 px-4 py-5 rounded relative text-center max-w-lg mx-auto mt-10">
  <i class='bx bxs-lock text-4xl text-[#D62828] mb-2'></i>
  <p class="font-semibold text-lg">Este conteúdo é exclusivo para assinantes.</p>
  <p class="text-sm mb-4">Assine agora para ter acesso completo às questões e simulações.</p>
  <button class="bg-[#D62828] hover:bg-[#b31f1f] text-white font-bold py-2 px-6 rounded-full text-sm mx-auto"
    [routerLink]="['/my-space/my-plan']">
    Assinar agora
  </button>
</div>

<div class="py-[50px] bg-white flex justify-between flex-wrap" *ngIf="!isLoading && !isFreePlan">
    <div class="flex flex-wrap w-full">
        <h6 class="text-[#4D748D] py-5">
            <i class='bx bx-pin'></i>
            Resumo
        </h6>

        <!--USER METRICS-->
        <div class="flex justify-between flex-wrap w-full">
            <div class="border text-white border-[#4D748D] bg-[--lightRed] my-5 rounded-lg p-5 flex flex-wrap w-[100%] flex-col text-center">
                <h6 class="font-bold text-white"><i class='bx bx-line-chart'></i> Relatório Geral</h6>
                <ul class="flex flex-col gap-3">
                    <li>
                        <span class="text-white">
                            <i class='bx bxs-check-circle'></i>
                            Total de questões respondidas:
                            <span class="text-white">{{total}}</span>
                        </span>
                    </li>
                    <li>
                        <span class="text-white">
                            <i class='bx bxs-calendar'></i>
                            Questões nos últimos 7 dias:
                            <span class="text-white">{{total7}}</span>
                        </span>
                    </li>
                    <li>
                        <span class="text-white">
                            <i class='bx bxs-calendar'></i>
                            Questões nos últimos 15 dias:
                            <span class="text-white">{{total15}}</span>
                        </span>
                    </li>
                    <li>
                        <span class="text-white">
                            <i class='bx bxs-calendar'></i>
                            Questões no último mês:
                            <span class="text-white">{{total30}}</span>
                        </span>
                    </li>
                    <li>
                        <span class="text-white">
                            <i class='bx bxs-bar-chart-alt-2'></i>
                            Média de questões respondidas por dia:
                            <span class="text-white">{{averagePerDay}}</span>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="w-[100%] py-5 text-center flex justify-between flex-col">
                <div class="mb-2 border border-[#dbdbdb] rounded-lg p-5 content-center bg-[--lightRed] text-white" style="height: 100%;">
                    <h6>Média de Acertos: {{correctPercentage}}%</h6>
                    <span>
                        <i class='bx bx-like'></i>
                        {{percentMessage}}
                    </span>
                </div>
                <div class="flex justify-between w-[100%]">
                    <div class="border border-[#dbdbdb] py-5 rounded-lg w-[49%] content-center bg-[--lightRed] text-white">
                        <h6>Ranking de Questões Respondidas</h6>
                        <span>
                            <i class='bx bx-book-open'></i>
                            Você está na posição {{answerRank}} no ranking global
                        </span>
                    </div>
                    <div class="border border-[#dbdbdb] py-5 rounded-lg w-[49%] content-center bg-[--lightRed] text-white">
                        <h6>Ranking de Acertos</h6>
                        <span>
                            <i class='bx bx-check'></i>
                            Você está na posição {{correctRank}} no ranking global
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <h6 class="text-[#4D748D] py-5 w-full">
            <i class='bx bx-pin'></i>
            Minhas métricas
        </h6>
        
        <!--CHARTS-->
        <div *ngIf="dates.length === 0" class="p-[20px] h-fit mb-[20px] rounded-[8px] border border-[#3D46F2] flex justify-center flex-col w-full">
            <div class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg mx-auto mb-2"></div>
            <span class="text-[--lightRed] text-center">Carregando...</span>
        </div>

        <div *ngIf="dates.length > 0" class="p-[20px] h-[600px] mb-[20px] rounded-[8px] border border-[#4D748D] w-full">
            <chart-line [labels]="dates" [corrects]="correctsData" [wrongs]="wrongsData"></chart-line>
        </div>

        <div class="flex justify-between flex-wrap gap-8 w-full" *ngIf="dates.length > 0">
            <div class="chart_container w-[48%]">
                <chart-donut [corrects]="correctsTotal" [wrongs]="wrongsTotal"></chart-donut>
            </div>
            <div class="chart_container w-[48%]">
                <canvas id="bancas_chart"></canvas>
            </div>
            <div class="chart_container w-[48%]">
                <canvas id="subjects_chart"></canvas>
            </div>
            <div class="chart_container w-[48%]">
                <canvas id="type_chart"></canvas>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="py-[250px] px-[50px] bg-white flex justify-center flex-wrap">
    <div class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg mx-auto mb-2"></div>
    <span class="text-[--lightRed] text-center w-full">Carregando estatísticas...</span>
</div>